module.exports = __webpack_public_path__ + "static/duraprime-44bbb33ba56df19db36e999e2ead3922.png";